import { useEffect } from "react";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const modalStyle = {
  background: "#1f1f2b",
  color: "#fff",
  padding: "20px",
  borderRadius: "12px",
  minWidth: "280px",
  maxWidth: "90%",
};

const actionsStyle = {
  display: "flex",
  gap: "8px",
  justifyContent: "flex-end",
};

const ConfirmModal = ({
  open,
  message,
  onConfirm,
  onCancel,
  loading = false,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  confirmClassName = "",
  cancelClassName = "",
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onCancel?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div style={overlayStyle} onClick={loading ? undefined : onCancel}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <p style={{ marginBottom: "16px" }}>{message}</p>
        <div style={actionsStyle}>
          <button
            type="button"
            className={confirmClassName}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Enviando..." : confirmLabel}
          </button>
          <button
            type="button"
            className={cancelClassName}
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
